import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';

export type TimeRange = 'day' | 'week' | 'month';

interface WhoopTimeRangeSelectorProps {
  value: TimeRange;
  onChange: (value: TimeRange) => void;
}

export default function WhoopTimeRangeSelector({ value, onChange }: WhoopTimeRangeSelectorProps) {
  return (
    <Tabs value={value} onValueChange={(v) => onChange(v as TimeRange)} className="w-full">
      <TabsList className="grid w-full grid-cols-3 bg-secondary/10">
        <TabsTrigger 
          value="day" 
          className="data-[state=active]:bg-primary data-[state=active]:text-primary-foreground"
        >
          Day
        </TabsTrigger>
        <TabsTrigger 
          value="week"
          className="data-[state=active]:bg-primary data-[state=active]:text-primary-foreground"
        >
          Week
        </TabsTrigger>
        <TabsTrigger 
          value="month"
          className="data-[state=active]:bg-primary data-[state=active]:text-primary-foreground"
        >
          Month
        </TabsTrigger>
      </TabsList>
    </Tabs>
  );
}
